import { createRef, useInstance } from 'intact-vue';
import { useState } from '../../hooks/useState';
import { isStringOrNumber, isNull } from 'intact-shared';
export function useStickyHeader(callbacks) {
  var instance = useInstance();
  var elementRef = createRef();
  var headRef = createRef();
  var stickHeader = useState(null);
  function excludeStickHeader(_ref) {
    var offsetTop = _ref.offsetTop;
    var _elementRef$value$get = elementRef.value.getBoundingClientRect(),
      bottom = _elementRef$value$get.bottom;
    return bottom <= offsetTop;
  }
  instance.on('$receive:stickHeader', function (v) {
    stickHeader.set(v === true ? 0 : isStringOrNumber(v) ? +v : null);
  });
  // when the scroll element scroll horizontally, scroll the sticky header too 
  callbacks.push(function (scrollLeft) {
    if (isNull(stickHeader.value)) return;
    var affixHeadWrapper = headRef.value.parentElement;
    affixHeadWrapper.scrollLeft = scrollLeft;
  });
  return {
    stickHeader: stickHeader,
    excludeStickHeader: excludeStickHeader,
    elementRef: elementRef,
    headRef: headRef
  };
}